// aluCatalog.js — Frente B.2 curated dropdown catalog + conditional logic
// Single source of truth for the aluminum line form (Duralumi).
// Lists derived from REAL Odoo production (categ_id=34, 3,000 lines).
// PENDING validation with Jose Luis (esp. Opens Swing-vs-Crank, LFO meaning).

// ============================================================================
// PRODUCT_TYPE VOCABULARY CONTRACT  (read before editing any product type)
// PRODUCT_TYPES is the single source of truth. Its string values are keys used
// by SIX coupled places. If you add/rename/remove a type here, you MUST update
// ALL of them or the model filter / auto-fill breaks SILENTLY:
//   1. PRODUCT_TYPES            (this list)
//   2. OPENS_BY_TYPE           (valid opens per type)
//   3. TYPE_DESC              (product description auto-fill)
//   4. CATALOG_TYPE_TO_SPEC   (visual catalog -> product_type mapping; keys are
//                               alu_catalog.type values, values must match here)
//   5. showHardware / showPanelConfig / showActiveSide (conditional UI by type)
//   6. DB table alu_type_series (compatibility matrix, migrations 054/055) --
//      product_type strings here MUST equal the ones seeded there, or the model
//      dropdown filter returns empty. Update via a new migration, not by hand.
// Doctrine: never leave the old vocabulary behind (e.g. 'Sliding'/'Door' generic
// are DEAD; use Sliding Window / Sliding Door / Hinged Door / etc).
// ============================================================================

// ============================================================================
// DOCTRINA DE DIVISIONES -- CONTRARIA A LA DE FIERRO. NO UNIFICAR.
//
// ALUMINIO: el divisor DECORATIVO cobra. El ESTRUCTURAL no.
//   Rejilla entre vidrios (GBG): +2.6014 USD/sqft de la unidad, aditivo
//   plano sobre el FOB. No es porcentaje: sobre base 17.93 es +14.5%, sobre
//   31.59 es +8.2%. Tampoco depende del numero de cuadros -- una unidad de
//   168 sqft paga lo mismo con 4 divisiones que con 40.
//   La division estructural NO cobra: una fija de 144 pulgadas de ancho
//   cuesta lo mismo por sqft que una de 72.
//
// FIERRO: los lites NO mueven precio. El precio de diseno por sqft y el
//   factor de vidrio ya embeben la configuracion de lites (validado contra
//   1,899 archivos de Melissa).
//
// Son reglas OPUESTAS y ninguna es intuitiva. Si estas aqui pensando que
// una de las dos esta mal porque no se parece a la otra: no lo esta.
//
// Evidencia: chat 'Divisiones y FOB de Doorwin', 2-ago-2026. Nueve pares
// exactos (misma pieza, mismo archivo, mismo dia) sobre bases 17.93 / 26.29
// / 31.59, jul-2025 a jul-2026. Sin deriva temporal (SO11789 V1 vs V7:
// ocho piezas con delta 0.0000 en seis meses y medio).
//
// Donde vive: tabla alu_cargos_atributo (migr 106). El motor NO lo suma:
// alu_catalogo_precios.grilles ya separa el precio y el lookup filtra por
// ese campo desde G.5. Ver pricingEngine.js, bloque de desglose informativo.
//
// SDL: NO medido. 91 lineas en solo 3 archivos, todas con rejilla, sin par
// interno. El campo grilles_sdl dispara el cargo de GBG por ser el unico
// disponible -- no asumir que SDL cuesta lo mismo.
// ============================================================================

export const PRODUCT_TYPES = [
  'Fixed/Picture', 'Window Wall', 'Casement', 'Awning', 'Tilt&Turn',
  'Sliding Window', 'Hung',
  'Hinged Door', 'Pivot Door', 'Sliding Door', 'Exterior Door', 'Bi-Fold Door',
  'Barn Door', 'Garage Door',
  'Storefront', 'Custom',
];

// Tres materiales, no dos. Urban Grove (E80/103/163/217) es alu-clad wood;
// Ornate Shield / Classic Custom es MADERA SOLIDA - otra linea, otro precio.
// Confundirlas fue el riesgo que Mau marco al cerrar la taxonomia.
export const FRAME_MATERIALS = ['Aluminum', 'Wood-Clad', 'Solid Wood'];

// Finish System = coating PROCESS (not color). RAL is a color standard -> lives in Finish Color.
export const FINISH_SYSTEMS = ['AkzoNobel Powder Coat', 'Anodized', 'Custom'];

export const FINISH_COLORS = ['Black', 'White', 'Dark Bronze', 'Custom/RAL', 'TBD'];

export const GLAZING_TYPES = ['Single', 'Double-IGU', 'Triple'];

// Makeups validos POR TIPO DE ACRISTALAMIENTO. Fuente: specs universales
// Doorwin + barrido de 95 productos del catalogo curado.
// Doble estandar 6+12Ar+6 | Triple 6+12Ar+6+12Ar+6 | 90% argon | Low-E.
// AMS usa 6mm (confirmado Mau). El argon va HORNEADO en el makeup.
// Retirados: 8+12Ar+8 y 6+24Ar+5 -> 0 apariciones en catalogo (error de captura).
export const MAKEUPS_BY_GLAZING = {
  'Single':     ['6MM', '8MM', '12MM', 'Custom'],
  // Ordenados por uso real en el corpus (alu_corpus_lineas, 3,822 lineas).
  // Criterio para entrar: 20+ lineas en 3+ proyectos. Se excluyen
  // 5+24Ar+6 (92 lineas pero 1 solo proyecto) y 6+24Ar+6 (20 lineas, 1 proyecto).
  // 6+24Ar+5 y 6+22Ar+5 se habian retirado en julio por creerse error de
  // captura; el corpus prueba que son reales y cuestan ~41% mas que el estandar.
  'Double-IGU': ['6+12Ar+6', '6+24Ar+5', '6+22Ar+5', '5+12Ar+5',
                 '6+18Ar+5', '3+12Ar+3', '6+12+6', 'Custom'],
  'Triple':     ['6+12Ar+6+12Ar+6', 'Custom'],
};
export const makeupsFor = (glazing_type) =>
  MAKEUPS_BY_GLAZING[glazing_type] || ['Custom'];
// Compat: union plana para consumidores legacy.
export const GLASS_MAKEUPS = [
  '6+12Ar+6', '6+24Ar+5', '6+22Ar+5', '5+12Ar+5', '6+18Ar+5', '3+12Ar+3',
  '6+12+6', '6+12Ar+6+12Ar+6', '6MM', '8MM', '12MM', 'Custom',
];

export const SPACERS = ['Warm-Edge TGI', 'Standard'];

export const HARDWARE_BRANDS = [
  'Roto', 'Siegenia', 'G-U', 'Hoppe', 'CMECH', 'N/A', 'Custom',
];

// LFO meaning pending JL; lives here (config), not in Opens.
// Configuraciones observadas en el corpus de cotizaciones Doorwin
// (alu_corpus_lineas, 3,822 lineas). Ordenadas por frecuencia real.
// O = panel fijo, X = hoja movil. Se lee de izquierda a derecha desde afuera.
// Se retiro 'OXXXO': cero apariciones en el historico.
export const PANEL_CONFIGS = [
  'OXXO',    // 140 - la mas vendida
  'OX',      //  34
  'XO',      //  22
  'XXO',     //  14
  'OXXXXO',  //  10
  'OXXX',    //  10
  'XX',      //   8
  'XOX',     //   6
  'XXXO',    //   4
  'OXO',     //   4
  'OXXXXX',  //   4
  'XOOX',    //   4
  'XXXX',    //   2
  'Custom',
];

// 'Both' solo aplica a puertas dobles/French (una hoja sola no puede ser 'Both').
export const ACTIVE_SIDES = ['Right', 'Left', 'Both'];
export const activeSidesFor = (opens) =>
  opens === 'French' ? ACTIVE_SIDES : ['Right', 'Left'];

// Grilles / SDL grid pattern style. The count lives in grille_cols x grille_rows.
export const GRILLE_PATTERNS = ['Colonial', 'Prairie', 'Perimeter', 'Diamond', 'Top Row', 'Custom'];

export const LOCATIONS = [
  'Entry', 'Front Door', 'Back Door', 'Patio', 'Living Room', 'Family Room',
  'Kitchen', 'Dining Room', 'Master Bedroom', 'Master Bath', 'Bathroom',
  'Bedroom', 'Office', 'Study', 'Hallway', 'Stairwell', 'Garage',
  'Laundry', 'Closet', 'Balcony', 'Sunroom', 'Basement',
];

// Opens options DRIVEN BY product type (validated vs 3,000 lines).
export const OPENS_BY_TYPE = {
  'Fixed/Picture':  ['Fixed / No-operable'],
  'Window Wall':    ['Fixed / No-operable'],
  'Casement':       ['Push-out', 'Crank Out'],
  'Awning':         ['Crank Out'],
  'Tilt&Turn':      ['Tilt & Turn'],
  'Sliding Window': ['Sliding'],
  'Hung':           ['Single Hung', 'Double Hung'],
  'Hinged Door':    ['Swing Out', 'Swing In', 'French'],
  'Pivot Door':     ['Pivot'],
  'Sliding Door':   ['Sliding', 'Lift-Slide'],
  'Exterior Door':  ['Swing Out', 'Swing In'],
  'Bi-Fold Door':   ['Bi-fold / Folding'],
  'Barn Door':      ['Sliding'],
  'Garage Door':    ['Sectional', 'Overhead', 'Rolling'],
  'Storefront':     ['Swing Out', 'Swing In', 'Fixed / No-operable'],
  'Custom':         [],
};

// Auto-fill for Product Description from the chosen Product Type.
const TYPE_DESC = {
  'Fixed/Picture':  'Fixed Window',
  'Window Wall':    'Window Wall',
  'Casement':       'Casement Window',
  'Awning':         'Awning Window',
  'Tilt&Turn':      'Tilt & Turn Window',
  'Sliding Window': 'Sliding Window',
  'Hung':           'Hung Window',
  'Hinged Door':    'Hinged Door',
  'Pivot Door':     'Pivot Door',
  'Sliding Door':   'Sliding Door',
  'Exterior Door':  'Exterior Door',
  'Bi-Fold Door':   'Bi-Fold Door',
  'Barn Door':      'Barn Door',
  'Garage Door':    'Garage Door',
  'Storefront':     'Storefront',
  'Custom':         '',
};
export const productDescFor = (type) => TYPE_DESC[type] || type || '';

// Maps a reference-catalog `type` (alu_catalog.type) to its structured spec
// (product_type + default opens). Default opens is EDITABLE after auto-fill.
// Keys lowercased to match String(type).toLowerCase(). Validated w/ José Luis 2026-06.
// Unmapped types => specForCatalogType returns null => no auto-fill (safe no-op).
export const CATALOG_TYPE_TO_SPEC = {
  'fixed window':        { product_type: 'Fixed/Picture', opens: 'Fixed / No-operable' },
  'casement window':     { product_type: 'Casement',      opens: 'Push-out' },
  'awning window':       { product_type: 'Awning',        opens: 'Crank Out' },
  'tilt & turn window':  { product_type: 'Tilt&Turn',     opens: 'Tilt & Turn' },
  'bifolding window':    { product_type: 'Bi-Fold Door',  opens: 'Bi-fold / Folding' },
  'window wall':         { product_type: 'Window Wall',   opens: 'Fixed / No-operable' },
  'sliding window':      { product_type: 'Sliding Window', opens: 'Sliding' },
  'hinged door':         { product_type: 'Hinged Door',   opens: '' },  // JL: in/out both common
  'french door':         { product_type: 'Hinged Door',   opens: 'French' },
  'pivot door':          { product_type: 'Pivot Door',    opens: 'Pivot' },
  'exterior door':       { product_type: 'Exterior Door', opens: '' },
  'storefront door':     { product_type: 'Storefront',    opens: '' },  // commercial, force choice
  'bifolding door':      { product_type: 'Bi-Fold Door',  opens: 'Bi-fold / Folding' },
  'sliding door':        { product_type: 'Sliding Door',  opens: 'Sliding',    mechanism: 'Sliding' },
  'lift & sliding door': { product_type: 'Sliding Door',  opens: 'Lift-Slide', mechanism: 'Lift-Slide' },
  'barn door':           { product_type: 'Barn Door',     opens: 'Sliding' },
  'sliding barn door':   { product_type: 'Barn Door',     opens: 'Sliding' },
  'garage door':         { product_type: 'Garage Door',   opens: '' },
};

// Extract panel config (OXXO / X / O) from a catalog spec_raw string.
// Robust to the 3 seen formats: "(OXXO)", "OXXO, 159S", and trailing "-X"/"-O".
// Returns null when nothing parseable -> caller falls back to size label.
export const configFromSpec = (spec_raw) => {
  const s = String(spec_raw || '');
  const multi = s.match(/\b([OX]{2,})\b/i) || s.match(/\(([OX]{2,})\)/i);
  if (multi) return multi[1].toUpperCase();
  const single = s.match(/-\s*([OX])\b/i);
  if (single) return single[1].toUpperCase();
  return null;
};

export const specForCatalogType = (type) =>
  CATALOG_TYPE_TO_SPEC[String(type || '').toLowerCase()] || null;

export const FLAG_DEFAULTS = { low_e: true, argon: true, tempered: true };

// El argon va HORNEADO en el makeup (6+12Ar+6 = camara de 12mm con argon).
// Capturarlo aparte permitia la contradiccion: makeup con Ar y checkbox
// desmarcado. Se deriva del string y deja de ser campo editable.
export const argonFromMakeup = (glass_makeup) =>
  /Ar/i.test(String(glass_makeup || ''));

export const DEFAULTS = {
  frame_material: 'Aluminum',
  finish_system:  'AkzoNobel Powder Coat',
  finish_color:   'Black',
  glazing_type:   'Double-IGU',
  glass_makeup:   '6+12Ar+6',
  spacer:         'Warm-Edge TGI',
  ...FLAG_DEFAULTS,
};

// Opens por tipo. Para Sliding Door, Opens y Mechanism son EL MISMO dato
// (Sliding / Lift-Slide): el mecanismo manda y Opens solo lo refleja, asi
// es imposible que se contradigan. El PDF sigue imprimiendo Opens.
export const opensFor = (type, mechanism) => {
  if (type === 'Sliding Door') return mechanism ? [mechanism] : [];
  return OPENS_BY_TYPE[type] || [];
};

// Valor mas comun de "opens" por tipo, medido en el corpus Doorwin
// (5,131 lineas de 999 cotizaciones). Doctrina de Mau: entre menos
// decisiones tome el vendedor, mejor - pero el default se marca como
// "auto" en la UI para que un valor equivocado no pase inadvertido.
// Si un tipo no esta aqui y su lista tiene UNA sola opcion, esa gana.
const DEFAULT_OPENS = {
  'Casement':      'Push-out',      // 44 lineas vs Crank Out (madera, Urban Grove 163)
  'Hinged Door':   'Swing Out',     // outswing domina en el corpus
  'Exterior Door': 'Swing Out',
  'Storefront':    'Swing Out',
  'Hung':          'Single Hung',   // SG Series: single hung es lo cotizado
  'Garage Door':   'Sectional',     // seccional es el estandar residencial
};

// Devuelve el valor con el que pre-llenar "opens", o '' si no hay uno claro.
// Regla: lista de una sola opcion -> esa. Varias -> el default medido.
// Sliding Door sin mechanism devuelve '' a proposito: primero se resuelve
// el mecanismo (Sliding vs Lift-Slide), que es lo que define la serie.
export const defaultOpensFor = (type, mechanism) => {
  const lista = opensFor(type, mechanism);
  if (lista.length === 1) return lista[0];
  const d = DEFAULT_OPENS[type];
  return d && lista.includes(d) ? d : '';
};

export const showHardware = (type) =>
  !['Fixed/Picture', 'Window Wall'].includes(type);

// Barn door corre sobre riel expuesto: el vendedor si elige configuracion
// (una hoja, dos hojas, hoja + panel fijo). Garage door NO: es seccional
// horizontal, no tiene notacion OX.
export const showPanelConfig = (type, opens) =>
  type === 'Sliding Door' || type === 'Sliding Window' || type === 'Barn Door'
  || opens === 'Bi-fold / Folding';

export const showActiveSide = (type, opens) =>
  ['Hinged Door', 'Pivot Door', 'Exterior Door', 'Storefront'].includes(type) && ['Swing Out', 'Swing In', 'Pivot', 'French'].includes(opens);

// Default installation rate (Buiria) derived from product type + opens.
// Pre-fills "Installation type" when install is enabled; vendor can still
// override (ambiguous cases). Pure lookup, no side effects. Same spirit as
// showPanelConfig/showActiveSide. Rate codes come from the buiria_rates table.
// PENDING José Luis: French door -> DOOR_PNL? · Storefront 110S/>16ft variants.
export const defaultInstallRate = (product_type, opens) => {
  switch (product_type) {
    case 'Pivot Door':      return 'DOOR_PIV';                 // pivot $700/u
    case 'Bi-Fold Door':    return 'DOOR_PNL';                 // per panel $300
    case 'Sliding Door':    return 'DOOR_PNL';                 // per panel $300
    case 'Barn Door':       return 'DOOR_PNL';                 // per panel $300
    case 'Garage Door':     return 'DOOR_PNL';                 // PENDIENTE Andro
    case 'Hinged Door':
    case 'Exterior Door':
      // French se instala POR PANEL (confirmado Andro): 300/panel.
      // El resto de abatibles: 600/unidad.
      return opens === 'French' ? 'DOOR_PNL' : 'DOOR_HNG';
    case 'Casement':
    case 'Awning':
    case 'Tilt&Turn':
    case 'Fixed/Picture':
    case 'Sliding Window':
    case 'Hung':            return 'WIN_REG';                  // $100/u
    case 'Storefront':      return 'WIN_SF';                   // $12/sf (110S/XL pending JL)
    case 'Window Wall':     return 'WIN_SF';                   // $12/sf
    default:                return '';                         // Custom -> vendor chooses
  }
};
export const showWoodCladInterior = (frame_material) =>
  frame_material === 'Wood-Clad';

// ---- BI-FOLD (per José Luis): outswing siempre; lock cada 2 paneles ----
// Pares (2/4/6) NO llevan llave exterior; impares (3/5/7) SÍ (panel independiente).
// Notación: "{n}P {plegado}" ej "4P 3L-1R". El "-1{lado}" es el panel-puerta independiente.
export const BIFOLD_PANELS = [2, 3, 4, 5, 6, 7];

// Formas de plegado disponibles según # de paneles
export const bifoldStackingOptions = (n) => {
  const p = parseInt(n);
  if (!p || p < 2) return [];
  const opts = [
    { key: 'L', label: 'All Left' },
    { key: 'R', label: 'All Right' },
  ];
  if (p % 2 === 0) {
    opts.push({ key: 'BP', label: 'Bi-parting (split center)' });
  } else {
    // impar: un panel independiente (puerta), el resto pliega al lado opuesto
    opts.push({ key: 'IND_R', label: 'Independent door Right' });
    opts.push({ key: 'IND_L', label: 'Independent door Left' });
  }
  return opts;
};

// ¿Esta config permite llave exterior? (solo impares, per José Luis)
export const bifoldAllowsExteriorKey = (n) => {
  const p = parseInt(n);
  return !!p && p % 2 === 1;
};

// Arma la notación: bifoldNotation(4,'IND_R',true) -> "4P 3L-1R · Ext. Key"
export const bifoldNotation = (n, stacking, extKey) => {
  const p = parseInt(n);
  if (!p || !stacking) return '';
  let fold = '';
  if (stacking === 'L') fold = `${p}L`;
  else if (stacking === 'R') fold = `${p}R`;
  else if (stacking === 'BP') { const h = p / 2; fold = `${h}L-${h}R`; }
  else if (stacking === 'IND_R') fold = `${p - 1}L-1R`; // puerta indep. a la derecha, resto pliega izq
  else if (stacking === 'IND_L') fold = `${p - 1}R-1L`; // puerta indep. a la izquierda, resto pliega der
  let s = `${p}P ${fold}`;
  if (extKey && bifoldAllowsExteriorKey(p)) s += ' · Ext. Key';
  return s;
};

// Extrae el # de paneles desde panel_config (fuente persistida).
// Bifold: "4P 3L-1R..." -> 4. Corrediza: "OXXO" -> 4. Sin match -> null.
export const panelCountFrom = (panel_config) => {
  const s = String(panel_config || '').trim();
  if (!s) return null;
  const mP = s.match(/^(\d+)\s*P/i);          // "4P ..."
  if (mP) return parseInt(mP[1]);
  const mOX = s.match(/^[OXox]+/);            // "OXXO"
  if (mOX) return mOX[0].length;
  return null;
};
